export default __webpack_public_path__ + "static/media/dehuv-back.d63e337c.png";